import { Pipe, PipeTransform } from "@angular/core";
import { I18nPipe } from "./i18n.pipe";

@Pipe({
    name: "i18nStepResult",
    pure: false // required to update the value when the promise is resolved
    ,
    standalone: false
})
export class I18nStepResultPipe extends I18nPipe implements PipeTransform {
  public transform(value: unknown, ...args: unknown[]): unknown {
    return super.transform(`step_result_${value}`, ...args);
  }
}
